// extracted by mini-css-extract-plugin
export var legendIndicator = "_ar-1";
export var legendRight = "_ar-0";